module.exports = __webpack_public_path__ + "static/divas3s-8c8bde20f4132dd966c3e75d7acef35b.jpg";